import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { SmtAuthGaurd } from "./auth/smartech-auth";
import { WhatsAppGuard } from "./auth/whats-app.guard";
import { PermissionGuard } from "./guards/permission.guard";

const routes: Routes = [
  {
    path: "product",
    loadChildren: () => import('./pages/product/product.module').then(m => m.ProductModule),
    canActivate: [SmtAuthGaurd]
  },
  {
    path: "getting-started",
    loadChildren:
      () => import('./pages/getting-started/getting-started.module').then(m => m.GettingStartedModule),
      canActivate:[SmtAuthGaurd]
  },
  {
    path: "settings",
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [SmtAuthGaurd],
    // data: { permissions: [
    //     { channel: 'email', resource: 'Settings', action: 'view' },
    //     { channel: 'whatsapp', resource: 'Template', action: 'view' }
    //   ],
    //   permissionsMode: 'any',
    // },
  },
  {
    path: "whatsapp",
    loadChildren: () => import('./pages/whatsapp/whatsapp.module').then(m => m.WhatsappModule),
    canActivate: [WhatsAppGuard, SmtAuthGaurd],
  },
  {
    path: "grcs",
    loadChildren: () => import('./pages/grcs/grcs.module').then(m => m.GrcsModule),
    canActivate: [SmtAuthGaurd],
  },
  {
    path: "dashboard",
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: {
      permissions: [
        { channel: 'email', resource: 'Dashboard', action: 'view' },
        { channel: 'sms', resource: 'Dashboard', action: 'view' },
        { channel: 'rcs', resource: 'Dashboard', action: 'view' },
        { channel: 'whatsapp', resource: 'Dashboard', action: 'view' },
        { channel: 'deflector', resource: 'Dashboard', action: 'view' },
      ],
      permissionsMode: 'any',
    },
  },
  {
    path: "opt",
    loadChildren: () => import('./pages/opt/opt.module').then(m => m.OptModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'whatsapp', resource: 'Blocklist', action: 'view' }] },
  },
  {
    path: "live",
    loadChildren: () => import('./pages/live/live.module').then(m => m.LiveModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: {
      permissions: [
        { channel: 'email', resource: 'LiveFeed', action: 'view' },
        { channel: 'whatsapp', resource: 'LiveFeed', action: 'view' },
        { channel: 'rcs', resource: 'LiveFeed', action: 'view' },
      ],
      permissionsMode: 'any',
    },
  },
  {
    path: "analytics",
    loadChildren: () => import('./pages/analytics/analytics.module').then(m => m.AnalyticsModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Reports', action: 'view' }] },
  },
  {
    path: "suppression",
    loadChildren: () => import('./pages/suppression/suppression.module').then(m => m.SuppressionModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Suppression', action: 'view' }] },
  },
  {
    path: "billings",
    loadChildren: () => import('./pages/billings/billings.module').then(m => m.BillingsModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Billing', action: 'view' }] },
  },
  {
    path: "notification",
    loadChildren:
      () => import('./pages/notification/notification.module').then(m => m.NotificationModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'MailAlerts', action: 'view' }] },
  },
  {
    path: "profile",
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Profile', action: 'view' }] },
  },
  {
    path: "help",
    loadChildren: () => import('./pages/help/help.module').then(m => m.HelpModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Help', action: 'view' }] },
  },
  {
    path: "setup",
    loadChildren: () => import('./pages/setup/setup.module').then(m => m.SetupModule),
    canActivate: [SmtAuthGaurd],
  },
  {
    path: "referral",
    loadChildren: () => import('./pages/refferal/refferal.module').then(m => m.RefferalModule),
    canActivate: [SmtAuthGaurd],
  },
  {
    path: "email-marketing",
    loadChildren:
      () => import('./pages/email-marketing/email-marketing.module').then(m => m.EmailMarketingModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'EmailMarketing', action: 'view' }] },
  },
  {
    path: "email-template",
    loadChildren:
      () => import('./pages/email-template/email-template.module').then(m => m.EmailTemplateModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Template', action: 'view' }] },
  },
  {
    path: "home-dashboard",
    loadChildren:
      () => import('./pages/new-home-dashboard/new-home-dashboard.module').then(m => m.NewHomeDashboardModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'email', resource: 'Dashboard', action: 'view' }] },
  },
  {
    path: "blocklist",
    loadChildren:
    () => import('./pages/blocklist/blocklist.module').then(m => m.BlocklistModule),
    canActivate: [PermissionGuard, SmtAuthGaurd],
    data: { permissions: [{ channel: 'rcs', resource: 'Blocklist', action: 'view' }] },
  },
  {
    path: "sms",
    loadChildren: () => import('./pages/sms/sms.module').then(m => m.SmsModule),
    canActivate: [SmtAuthGaurd],
  },
  {
    path: "demo",
    loadChildren: () => import('./shared/nxt-demo.module').then((m) => m.NxtDemoModule),
    // canActivate: [SmtAuthGaurd],
  },
  {
    path: "",
    redirectTo: "setup",
    pathMatch: "full",
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
